import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// import { GlobalService } from 'src/app/aplicaciones-modulos/vdi/services/global.service';
import { sustentosModulo } from '../../diccionarios/sustentosModulo';
import { CatalogoService } from '../../services/catalogo.service';
import { FacturaService } from '../../services/factura.service';
import { ExportarService } from '../../services/exportar.service';
import { AngenciasModel } from '../../models/agenciasModel';
import { ExportaModel } from '../../models/exportaModel';
import { ClaveValorModel } from '../../models/claveValorModel';
import { ResponseExportacionModel } from "../../models/responseExportacionModel";
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector: 'app-exportar',
  templateUrl: './exportar.component.html',
  styleUrls: ['./exportar.component.css']
})
export class ExportarComponent implements OnInit {

  @ViewChild('agGrid') agGrid: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  rowData: ResponseExportacionModel[] = [];

  columnDefs: any[];//aggrid
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  sustentosModulo: any = {};

  casrgaDoc: boolean = false;

  cmbPeriodo: ClaveValorModel[] = [];
  cmbAnio: ClaveValorModel[] = [];
  cmbTipoDescarga: ClaveValorModel[] = [];
  cmbTipoArchivoDescarga: ClaveValorModel[] = [];
  cmbOfiVentas: any[] = [];
  cmbEmpresas: any[] = [];
  loading: boolean = false;
  listaVacia: boolean = true;

  value: string;
  formulario: FormGroup;//formulario
  formOptions: FormGroup;
  formSustento: FormGroup;
  selectedAnios: any[] = [];
  selectedPeridos: any[] = [];
  selectedAgencias: any[] = [];
  selectedEmpresas: any[] = [];
  selectedTipoDescarga: any[] = [];
  selectedTipoArchivoDescarga: any[] = [];
  clienteIcon: string;
  fechaCalendarioIcon: string;
  empresaIcon: string;
  agenciaIcon: string;
  periodoIcon: string;
  fechaRegIcon: string;
  checkOptionIcon: string;

  resposiveFull: string;

  constructor(private fb: FormBuilder,
    public sanitizer: DomSanitizer,
    private _global: DatosMaestrosService,
    private _catalogo: CatalogoService,
    private _factura: FacturaService,
    private _exportacion: ExportarService,
    private _util: UtilsService) { }

  ngOnInit() {
    setTimeout(() => {
      this.cmbPeriodo = this._catalogo.getPeriodo();
    }, 200);
    this.cmbTipoDescarga = this._catalogo.getCatalogoTipoDescarga();
    this.cmbTipoArchivoDescarga = this._catalogo.getCatalogoTipoArchivoDescarga();
    this.getAnios();
    this.getOficinasVentas();
    this.getAllEmpresas();
    this.cargarIconos();
    this.sustentosModulo = sustentosModulo;
    this.resposiveFull = this.sustentosModulo.div.resposiveFull;
    this.cargarGrid();

    this.formulario = this.fb.group({
      clienteDesde: [''],
      clienteHasta: [''],
      fechaRegIni: [''],
      fechaRegFin: [''],
      tipoDescarga: ['Retencion'],
      tipoArchivoDescarga: ['Retencion'],
    });

    this.cargarExportaciones();

    setInterval(() => {
      this.cargarExportaciones();
    }, 5000);
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        filter: true,
        width: 80,
      },
      {
        headerName: 'Usuario',
        field: 'usuId',
        filter: true,
        width: 150,
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fechaIni',
        filter: true,
        width: 200,
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechaFin',
        filter: true,
        width: 200,
      },
      {
        headerName: '# Exportado',
        field: 'numSustentos',
        filter: true,
        width: 150,
      },
      {
        headerName: '% Avance',
        field: 'porcAvance',
        filter: true,
        width: 250,
        cellRenderer: function (params) {
          let div = document.createElement("div");
          div.style.width = (params.value == '0' ? '8' : params.value) + '%';
          div.textContent = params.value + '%';
          div.setAttribute('class', 'progress-bar progress-bar-striped bg-info');
          div.setAttribute('role', 'progressbar');
          div.setAttribute('aria-valuenow', (params.value == '0' ? '8' : params.value));
          div.setAttribute('aria-valuemin', '0');
          div.setAttribute('aria-valuemax', '100');
          return div;
        },
      },
      {
        headerName: 'Estado',
        field: 'estado',
        filter: true,
        width: 120,
      },
    ];
  }

  cargarIconos() {
    this.clienteIcon = this._catalogo.catalogoIcon().cliente;
    this.fechaCalendarioIcon = this._catalogo.catalogoIcon().calendario;
    this.empresaIcon = this._catalogo.catalogoIcon().empresa;
    this.agenciaIcon = this._catalogo.catalogoIcon().agencia;
    this.periodoIcon = this._catalogo.catalogoIcon().periodo;
    this.fechaRegIcon = this._catalogo.catalogoIcon().fechaReg;
    this.checkOptionIcon = this._catalogo.catalogoIcon().checkOption;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.formulario.get('buscar').value);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAnios() {
    this._factura.getAnios().subscribe((res: ClaveValorModel[]) => {
      this.cmbAnio = res;
    }, (err) => {
      this.cmbAnio = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getOficinasVentas() {
    this._global.getAllOficinasVentas().subscribe((res: AngenciasModel[]) => {
      this.cmbOfiVentas = res;
      this.cmbOfiVentas.map((e: AngenciasModel) => {
        e['cadena'] = e.idOficinaVenta + '-' + e.dscaOficinaVenta
      });
    }, (err) => {
      this.cmbOfiVentas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getAllEmpresas() {
    this._global.getAllEmpresas().subscribe((res: any) => {
      this.cmbEmpresas = res;
    }, (err) => {
      this.cmbEmpresas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  obtenerAnios(anios) {
    this.selectedAnios = anios;
    this.selectedAnios = this.getValueArray(this.selectedAnios);
    console.log(this.selectedAnios);
  }

  obtenerPeriodo(periodos) {
    this.selectedPeridos = periodos;
    this.selectedPeridos = this.getValueArray(this.selectedPeridos);
    console.log(this.selectedPeridos);
  }

  obtenerAngencias(agencias) {
    this.selectedAgencias = agencias;
    this.selectedAgencias = this.getValueArray(this.selectedAgencias, 'idOficinaVenta');
    console.log(this.selectedAgencias);
  }

  obtenerEmpresas(empresas) {
    this.selectedEmpresas = empresas;
    this.selectedEmpresas = this.getValueArray(this.selectedEmpresas, 'idEmpresa');
    console.log(this.selectedEmpresas);
  }

  obtenerTipoDescarga(tipoDescarga) {
    this.selectedTipoDescarga = tipoDescarga;
    this.selectedTipoDescarga = this.getValueArray(this.selectedTipoDescarga);
    console.log(this.selectedTipoDescarga);
  }

  validarTipoDescarga() {
    if (this.formulario.get('tipoDescarga').value == "Carga") {
      this.casrgaDoc = true;
    } else {
      this.casrgaDoc = false;
    }
  }

  getValueArray(data, clave?) {
    let key = (clave) ? clave : 'clave';
    let respuesta: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const el = data[i];
      respuesta.push(el[key]);
    }
    return respuesta;
  }

  cargarExportaciones() {
    // this.loading = true;
    this._exportacion.getAllExportacion().subscribe((res: ResponseExportacionModel[]) => {
      this.rowData = res;
      this.listaVacia = false;
      // this.loading = false;
    }, (err) => {
      // this.loading = false;
      this.rowData = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  devolverObjeto(data): ExportaModel {
    const enviarObjeto = new ExportaModel(data);
    return enviarObjeto;
  }

  setFormData() {
    let data = {
      anios: this.selectedAnios,
      meses: this.selectedPeridos,
      oficinas: this.selectedAgencias,
      empresas: this.selectedEmpresas,
      clienteIni: this.formulario.get('clienteDesde').value,
      clienteFin: this.formulario.get('clienteHasta').value,
      fechaIni: this.formulario.get('fechaRegIni').value != '' ? this.formulario.get('fechaRegIni').value : null,
      fechaFin: this.formulario.get('fechaRegFin').value != '' ? this.formulario.get('fechaRegFin').value : null,
      tipoDocExport: this.formulario.get('tipoDescarga').value,
      cargaTipoDocExport: this.formulario.get('tipoArchivoDescarga').value,
    }
    let objecto = {
      data: JSON.stringify(data),
      file: null,//this.formulario.get('multipart').value,
    };
    const formData = new FormData();
    Object.keys(objecto).forEach(key => formData.append(key, objecto[key]));
    return formData;
  }

  exportarSustentos() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea exportar los siguientes sustentos?',
        text: '',
        action: 'Exportar',
        funcion: this._exportacion.postExportar(this.setFormData()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      console.log(res);
      this.formSustento.reset();
      this.fileInput.nativeElement.value = '';
      this.cargarExportaciones();
    }).catch((err) => { console.log('Error ' + err); });
  }

  decargarArchivo(fichero: string) {
    this.loading = true;
    this._exportacion.getExportaDownload(fichero).subscribe((res: any) => {
      this.loading = false;
      this._util.mensajeOKVisto("Se descargo correctamente el fichero.");
      this._util.descargarArchivo(res.nombre, res.contenido, 'zip');
    }, (err) => {
      this._util.mensajeErrorVisto(err.error.mensaje);
      this.loading = false;
    });
  }

}
